// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LazyImage{max-width:100%;max-height:100%;width:auto;height:auto;vertical-align:middle}", "",{"version":3,"sources":["webpack://./src/components/Widgets/LazyImage.vue"],"names":[],"mappings":"AAEA,WACE,cAAA,CACA,eAAA,CACA,UAAA,CACA,WAAA,CACA,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
